import React, { useState, useEffect } from 'react';
import _, { lastIndexOf } from 'lodash';
import 'draft-js/dist/Draft.css';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Popover from '@mui/material/Popover';
import Tooltip from '@mui/material/Tooltip';

import { handleColorSystem } from '../../customComponent/colorSystem';

import {
  HelpOutlineIcon,
  EditOutlinedIcon,
  HighlightOffIcon,
  ErrorOutlineIcon
} from '../../../constants/images';

import theme from '../../../theme';

import SortFields from '../SortFields';

const fieldsBlockHeightS = '395px';

const getOriginalFieldName = (allFields, name) => {
  const target = _.flatMap(allFields, item => {
    return _(item.child).filter({ expression: name }).value()
  })[0];
  return target.name;
}

const LineFieldsSelected = (props) => {
  const {
    allfields,
    handleDeleteFields,
    currentSheetName,
    allDisplayFields,
    currentSheetSelectFields,
    setCurrentSheetSelectFields,
    currenOptionFields,
    setCurrenOptionFields,
    setSelectedGeneralFields,
    setSelectedCustomFields,
    updateSortFields,
    setUpdateSortFields,
    campaignGoalsList,
    handleUpdateSortFields
  } = props;

  const [anchorEl, setAnchorEl] = useState(null);
  const popOpen = Boolean(anchorEl);
  const { colorSystem, mainColor, lightColor, darkColor, w01Color } = handleColorSystem('LINE');


  const closeOptionFieldsName = () => {

    setAnchorEl(null);

    if (currenOptionFields.name === '') return;

    setCurrentSheetSelectFields(prev => {
      return prev.map(el => {
        if (el.expression === currenOptionFields.expression) {
          el.name = currenOptionFields.name;
        }
        return el;
      })
    })

    setSelectedGeneralFields(prev => {
      return prev.map(el => {
        if (el.expression === currenOptionFields.expression) {
          el.name = currenOptionFields.name;
        }
        return el;
      })
    })

    setSelectedCustomFields(prev => {
      return prev.map(el => {
        if (el.expression === currenOptionFields.expression) {
          el.name = currenOptionFields.name;
        }
        return el;
      })
    })
  }

  return (
    <Box sx={{ flex: 1.6 }}>
      <Box sx={{ padding: '20px 16px 4px' }}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-end',
            paddingBottom: '4px',
            borderBottom: `1px solid ${theme.palette.grey.w200}`
          }}
        >
          <Typography>
            已選欄位
            <Tooltip title="點擊編輯圖示後可更改欄位名稱" placement="bottom-start">
              <HelpOutlineIcon variant="dark" />
            </Tooltip>
          </Typography>

          <SortFields
            media="LINE"
            allfields={allfields}
            excelSheetSelected={campaignGoalsList.map((el) => el.campaignGoalEng)}
            updateSortFields={updateSortFields}
            setUpdateSortFields={setUpdateSortFields}
            handleUpdateSortFields={handleUpdateSortFields}
          />
        </Box>
      </Box>

      <Box
        sx={{
          height: fieldsBlockHeightS,
          overflow: 'auto',
          padding: '8px 16px 0',
          transition: 'all .5s'
        }}
      >
        {
          currentSheetName === "" && !campaignGoalsList?.length ?
            (<Box
              sx={{
                height: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                color: theme.palette.grey.w300,
              }}
            >
              <ErrorOutlineIcon sx={{ right: '4px' }} />
              無資料
            </Box>) : ""
        }
        {
          currentSheetName === "" && campaignGoalsList?.length ?
            (<Box
              sx={{
                height: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                color: theme.palette.grey.w300,
              }}
            >
              <ErrorOutlineIcon sx={{ right: '4px' }} />
              請先點選廣告目標
            </Box>) : ""
        }
        {
          currentSheetName === "" ? "" :
            currentSheetSelectFields.length > 0 &&
            currentSheetSelectFields.map(el => {
              return (
                <Box
                  key={el.expression}
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: '8px',
                    padding: '4px 8px 4px 4px',
                    border: `1px solid ${theme.palette.grey.w200}`,
                    borderRadius: '4px'
                  }}
                >
                  <HighlightOffIcon
                    variant="dark"
                    sx={{
                      marginRight: '4px',
                      '&:hover': {
                        color: mainColor,
                        cursor: 'pointer'
                      }
                    }}
                    onClick={(e) => handleDeleteFields(e, el, 'deleteSheet')}
                  />

                  <Typography
                    sx={{
                      flex: 1,
                      marginRight: '8px',
                      borderRight: `1px solid ${theme.palette.grey.w200}`,
                    }}
                  >{el.name}</Typography>

                  <EditOutlinedIcon
                    variant="dark"
                    sx={{
                      '&:hover': {
                        color: mainColor,
                        cursor: 'pointer'
                      }
                    }}
                    onClick={(e) => {
                      setAnchorEl(e.currentTarget);
                      setCurrenOptionFields(el);
                    }}
                  />

                </Box>
              )
            })
        }
        {
          currenOptionFields &&
          <Popover
            open={popOpen}
            anchorEl={anchorEl}
            onClose={closeOptionFieldsName}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
          >
            <Box
              sx={{
                width: '240px',
                padding: '16px'
              }}
            >
              <Typography variant="caption">
                請輸入自訂名稱
              </Typography>
              <TextField
                variant="standard"
                id="customOptionalFieldName"
                name="customOptionalFieldName"
                value={currenOptionFields.name}
                onChange={(e) => {
                  setCurrenOptionFields(prev => ({ ...prev, name: e.target.value }))
                }}
                fullWidth
              />
              <Typography
                variant="caption"
                sx={{
                  color: theme.palette.grey.w600
                }}
              >
                來源欄位：{getOriginalFieldName(allDisplayFields, currenOptionFields.expression)}
              </Typography>
            </Box>

          </Popover>
        }
      </Box>
    </Box>
  )
}

export default LineFieldsSelected;